import { render, staticRenderFns } from "./DialogFactory.vue?vue&type=template&id=52740411&"
import script from "./DialogFactory.vue?vue&type=script&lang=ts&"
export * from "./DialogFactory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports